// extracted by mini-css-extract-plugin
module.exports = {"arrowBody":"BackArrow_arrowBody__11EfV"};